import _ from 'lodash'
import numeral from 'numeral'

export const getSkin = (trip, quotation, models, context, mode) => {
  const partner = _.find(models.partners, { mode })
  switch (mode) {
    case 'default':
      return {
        header: 'Make a booking',
        bgColor: null,
        bgColorLight: null,
        pickupLocation: !(quotation.split && trip == 2),
        returnLocation: !(quotation.split && trip == 1),
        returnLocationToggle: !(
          quotation.split ||
          quotation.trips[quotation.trip].return != '' ||
          _.startsWith(location.pathname, '/bookings/search')
        ),
        age: !quotation.split,
        promocode: !quotation.split,
      }
      break
    default:
      return {
        header: _.get(partner, 'booking_widget_title', ''),
        bgColor: '#111111',
        bgColorLight: '#1a1a1a',
        pickupLocation: true,
        returnLocation: true,
        returnLocationToggle: !(
          quotation.trips[quotation.trip].return != '' ||
          _.startsWith(location.pathname, '/bookings/search')
        ),
        age: true,
        promocode: false,
      }
      break
  }
}
